import { ValuationType } from "common/types/common.types";

export const getValuationTypeLabel = (
  valuationType: ValuationType | undefined,
  t: (key: string) => string
): string => {
  if (!valuationType) return "-";

  switch (valuationType) {
    case ValuationType.FullReport:
      return t("propertyForm.valuationType.fullReport.title");
    case ValuationType.PriceCheck:
      return t("propertyForm.valuationType.priceCheck.title");
    case ValuationType.LocationCheck:
      return t("propertyForm.valuationType.locationCheck.title");
    default:
      return "-";
  }
};
